import React, { useState, useEffect } from "react";
import api from "../services/api";

export default function FinanzasDebug() {
  const [sueldos, setSueldos] = useState([]);
  const [auditorias, setAuditorias] = useState([]);
  const [gastos, setGastos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    cargarDatos();
  }, []);

  const cargarDatos = async () => {
    setLoading(true);
    setError("");
    
    try {
      const resSueldos = await api.get("/sueldos");
      setSueldos(resSueldos.data.data || []);

      const resAuditorias = await api.get("/finanzas/categorizadas");
      
      // Buscar auditorías entregadas no pagadas
      const auditoriasEntregadas = resAuditorias.data?.audits?.filter(audit => 
        audit.estado === 'entregada' && !audit.pagada
      ) || [];
      
      setAuditorias(auditoriasEntregadas);

      const resGastos = await api.get("/finanzas/movimientos?tipo=egreso");
      setGastos(resGastos.data || []);

    } catch (error) {
      console.error("❌ Error:", error);
      setError(error.response?.data?.error || error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: "20px" }}>
      <h1>🔧 DEBUG - Datos de Finanzas</h1>
      
      {error && (
        <div style={{ background: "#f8d7da", color: "#721c24", padding: "10px", margin: "10px 0", borderRadius: "4px" }}>
          Error: {error}
        </div>
      )}

      {loading ? (
        <div>⏳ Cargando...</div>
      ) : (
        <div>
          <div style={{ marginBottom: "30px" }}>
            <h2>💰 Sueldos ({sueldos.length})</h2>
            {sueldos.length > 0 ? (
              <table style={{ width: "100%", border: "1px solid #ccc", borderCollapse: "collapse" }}>
                <thead>
                  <tr style={{ background: "#f5f5f5" }}>
                    <th style={{ border: "1px solid #ccc", padding: "8px" }}>ID</th>
                    <th style={{ border: "1px solid #ccc", padding: "8px" }}>Operador</th>
                    <th style={{ border: "1px solid #ccc", padding: "8px" }}>Monto</th>
                    <th style={{ border: "1px solid #ccc", padding: "8px" }}>Estado</th>
                  </tr>
                </thead>
                <tbody>
                  {sueldos.map(sueldo => (
                    <tr key={sueldo.id}>
                      <td style={{ border: "1px solid #ccc", padding: "8px" }}>{sueldo.id}</td>
                      <td style={{ border: "1px solid #ccc", padding: "8px" }}>{sueldo.operador?.name || 'Sin nombre'}</td>
                      <td style={{ border: "1px solid #ccc", padding: "8px" }}>${parseFloat(sueldo.sueldoFinal || 0).toLocaleString()}</td>
                      <td style={{ border: "1px solid #ccc", padding: "8px" }}>{sueldo.estado}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <p>No hay sueldos</p>
            )}
          </div>

          <div style={{ marginBottom: "30px" }}>
            <h2>📋 Auditorías ({auditorias.length})</h2>
            {auditorias.length > 0 ? (
              <table style={{ width: "100%", border: "1px solid #ccc", borderCollapse: "collapse" }}>
                <thead>
                  <tr style={{ background: "#f5f5f5" }}>
                    <th style={{ border: "1px solid #ccc", padding: "8px" }}>ID</th>
                    <th style={{ border: "1px solid #ccc", padding: "8px" }}>Cliente</th>
                    <th style={{ border: "1px solid #ccc", padding: "8px" }}>Precio</th>
                    <th style={{ border: "1px solid #ccc", padding: "8px" }}>Estado</th>
                  </tr>
                </thead>
                <tbody>
                  {auditorias.map(audit => (
                    <tr key={audit.id}>
                      <td style={{ border: "1px solid #ccc", padding: "8px" }}>{audit.id}</td>
                      <td style={{ border: "1px solid #ccc", padding: "8px" }}>{audit.client?.nombre || 'Sin nombre'}</td>
                      <td style={{ border: "1px solid #ccc", padding: "8px" }}>${parseFloat(audit.precioTotal || 0).toLocaleString()}</td>
                      <td style={{ border: "1px solid #ccc", padding: "8px" }}>{audit.estado}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <p>No hay auditorías</p>
            )}
          </div>

          <div style={{ marginBottom: "30px" }}>
            <h2>🏪 Gastos ({gastos.length})</h2>
            {gastos.length > 0 ? (
              <table style={{ width: "100%", border: "1px solid #ccc", borderCollapse: "collapse" }}>
                <thead>
                  <tr style={{ background: "#f5f5f5" }}>
                    <th style={{ border: "1px solid #ccc", padding: "8px" }}>Concepto</th>
                    <th style={{ border: "1px solid #ccc", padding: "8px" }}>Monto</th>
                    <th style={{ border: "1px solid #ccc", padding: "8px" }}>Fecha</th>
                  </tr>
                </thead>
                <tbody>
                  {gastos.map((gasto, i) => (
                    <tr key={i}>
                      <td style={{ border: "1px solid #ccc", padding: "8px" }}>{gasto.data?.concepto || 'Sin concepto'}</td>
                      <td style={{ border: "1px solid #ccc", padding: "8px" }}>-${parseFloat(gasto.data?.monto || 0).toLocaleString()}</td>
                      <td style={{ border: "1px solid #ccc", padding: "8px" }}>{gasto.data?.fecha || 'Sin fecha'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <p>No hay gastos</p>
            )}
          </div>

          <button onClick={cargarDatos} style={{ padding: "10px 20px", background: "#007bff", color: "white", border: "none", borderRadius: "4px" }}>
            🔄 Recargar Datos
          </button>
        </div>
      )}
    </div>
  );
}